// src/components/products/ProductForm/TourDetailsSections/TourDescriptionsSection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";

const TourDescriptionsSection = ({
    formData,
    errors,
    activeLang,
    handleMultiLangChange,
}) => {
    const showArabic = activeLang === "ar";
    const showEnglish = activeLang === "en";

    return (
        <Grid container spacing={3}>
            {/* Long Description - Arabic */}
            {showArabic && (
                <Grid item xs={12}>
                    <FormInput
                        label="الوصف التفصيلي (عربي)"
                        type="editor"
                        textareaRows={200}
                        name="long_description_ar"
                        value={formData.long_description?.ar || ''}
                        onChange={(e) => handleMultiLangChange('long_description', 'ar', e.target.value)}
                        rows={5}
                        error={!!errors.long_description_ar}
                        helperText={errors.long_description_ar}
                    />
                </Grid>
            )}

            {/* Long Description - English */}
            {showEnglish && (
                <Grid item xs={12}>
                    <FormInput
                        label="Long Description (English)"
                        type="editor"
                        textareaRows={200}
                        name="long_description_en"
                        value={formData.long_description?.en || ''}
                        onChange={(e) => handleMultiLangChange('long_description', 'en', e.target.value)}
                        rows={5}
                        error={!!errors.long_description_en}
                        helperText={errors.long_description_en}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default TourDescriptionsSection;
